import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { HOME } from "@/constants/testIds";

export function CtaEmailCapture() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await api.post("/subscribers/newsletter", { email });
      setStatus("done");
      setEmail("");
    } catch (err) {
      setStatus("error");
    }
  };

  if (status === "done") {
    return <p data-testid={HOME.ctaEmailSuccess} className="text-[#1E3A6E] font-medium text-sm">You're on the list — thank you.</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 max-w-sm mx-auto">
      <Input
        type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)}
        data-testid={HOME.ctaEmailInput}
        className="bg-white border-zinc-300 text-zinc-950 text-sm h-9 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none"
      />
      <Button type="submit" disabled={status === "loading"} data-testid={HOME.ctaEmailSubmit} size="sm" variant="outline" className="border-zinc-300 text-zinc-950 rounded-none hover:border-zinc-950 h-9 whitespace-nowrap">
        {status === "loading" ? "Joining..." : "Join Email List"}
      </Button>
    </form>
  );
}
